<div class="NgxEditor__Wrapper" (click)="focusEditor()">
  <label for="richTextEditor" class="file_label" style="margin-right: 10px;">{{ label }}</label>
  <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"></ngx-editor-menu>
  <ngx-editor
    #ngxEditor
    [editor]="editor"
    [ngModelOptions]="{ standalone: true }"
    [disabled]="disable"
    [placeholder]="placeHolder"
    class="editor-content"
    [(ngModel)]="richTextValue"
    (ngModelChange)="onEditorChange()"
  >
  </ngx-editor>
</div>
